export default "/images/35db2f1f5cdaf7450b03961943c3f978.avif";